import { useState } from "react";
import axios from "axios";
import api from "../../api";
import { useNavigate, useSearchParams } from "react-router-dom";

const SignUp = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [fullname, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});

  const callbackUrl = searchParams.get("returnUrl") || "/";

  const handleValueChange = (type, value) => {
    if (type === "FULLNAME") setName(value);
    if (type === "EMAIL") setEmail(value);
    if (type === "MOBILE") setMobile(value);
    if (type === "PASSWORD") setPassword(value);
  };

 
  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
 
    if (!email) newErrors.email = "Email is required.";
    else if (!emailRegex.test(email))
      newErrors.email = "Please enter a valid email.";
    else if (!email.endsWith("@oges.co") && !email.endsWith("@ongc.co.in"))
      newErrors.email = "Email must be from oges.co or ongc.co.in domain.";
 
    if (!password) newErrors.password = "Password is required.";
    else if (password.length < 6)
      newErrors.password = "Password must be at least 6 characters.";
 
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async () => {
    if (!validate()) return;

    setMessage("Signing up...");

    const payload = { fullname, email, mobile, password };

    try {
      // const res = await axios.post("/api/register", payload);
      const res = await api.post("/register", payload);

      setMessage(res?.data?.message || "User registered successfully");

      setTimeout(() => {
        navigate(`/login?returnUrl=${encodeURIComponent(callbackUrl)}`);
      }, 800);
    } catch (err) {
      setMessage(err?.response?.data?.message || "Something went wrong");
    }
  };

  const handleNavigate = () => {
    navigate(`/login?returnUrl=${encodeURIComponent(callbackUrl)}`);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <div
        className="elementor-widget-container"
        style={{
          width: "40%",
          minWidth: "320px",
          background: "#111",
          padding: "35px",
          borderRadius: "12px",
          boxShadow: "0 0 20px rgba(255,255,255,0.08)",
          color: "white",
        }}
      >
        <h4
          className="text-gradient"
          style={{
            textAlign: "left",
            fontSize: 30,
            lineHeight: "normal",
            color: "#62d6e5",
          }}
        >
          Signup
        </h4>

        {/* FULL NAME */}
        <div style={{ marginTop: "20px" }}>
          <label style={{ marginBottom: 6, display: "block", fontSize: 14 }}>
            Full Name*
          </label>
          <input
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "10px",
              borderRadius: "6px",
              border: "1px solid #333",
              background: "#222",
              color: "white",
            }}
            type="text"
            value={fullname}
            onChange={(e) => handleValueChange("FULLNAME", e.target.value)}
          />
          {errors.fullname && (
            <p style={{ color: "red", marginTop: 0 }}>{errors.fullname}</p>
          )}
        </div>

        {/* EMAIL */}
        <div>
          <label style={{ marginBottom: 6, display: "block", fontSize: 14 }}>
            Email*
          </label>
          <input
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "10px",
              borderRadius: "6px",
              border: "1px solid #333",
              background: "#222",
              color: "white",
            }}
            type="email"
            value={email}
            onChange={(e) => handleValueChange("EMAIL", e.target.value)}
          />
          {errors.email && (
            <p style={{ color: "red", marginTop: 0 }}>{errors.email}</p>
          )}
        </div>

        {/* MOBILE */}
        <div>
          <label style={{ marginBottom: 6, display: "block", fontSize: 14 }}>
            Mobile Number*
          </label>
          <input
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "10px",
              borderRadius: "6px",
              border: "1px solid #333",
              background: "#222",
              color: "white",
            }}
            type="tel"
            value={mobile}
            onChange={(e) => handleValueChange("MOBILE", e.target.value)}
          />
          {errors.mobile && (
            <p style={{ color: "red", marginTop: 0 }}>{errors.mobile}</p>
          )}
        </div>

        {/* PASSWORD */}
        <div>
          <label style={{ marginBottom: 6, display: "block", fontSize: 14 }}>
            Password*
          </label>
          <input
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "10px",
              borderRadius: "6px",
              border: "1px solid #333",
              background: "#222",
              color: "white",
            }}
            type="password"
            value={password}
            onChange={(e) => handleValueChange("PASSWORD", e.target.value)}
          />
          {errors.password && (
            <p style={{ color: "red", marginTop: 0 }}>{errors.password}</p>
          )}
        </div>

        {/* LOGIN LINK */}
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <small>Already have an account?</small>&nbsp;
          <small
            style={{
              width: "fit-content",
              color: "#62d6e5",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={handleNavigate}
          >
            Go to Login
          </small>
        </div>

        {/* SIGNUP BUTTON */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            style={{
              background: "#62d6e5",
              color: "#000",
              width: "fit-content",
              height: 45,
              fontSize: 16,
              padding: "0px 35px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              fontWeight: "600",
            }}
            type="button"
            onClick={handleSubmit}
          >
            Signup
          </button>
        </div>

        <div>
          <p style={{ color: "red", marginTop: "15px" }}>{message}</p>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
